module.exports = __webpack_public_path__ + "img/01.35c329bc.jpg";